import { render, staticRenderFns } from "./DrinkGrid.vue?vue&type=template&id=1167da00&scoped=true&"
import script from "./DrinkGrid.vue?vue&type=script&lang=js&"
export * from "./DrinkGrid.vue?vue&type=script&lang=js&"
import style0 from "./DrinkGrid.vue?vue&type=style&index=0&id=1167da00&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167da00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrinkCardBeer: require('/opt/build/repo/components/DrinkCardBeer.vue').default})
